export function getPriceFromExperienceProduct(
  value: string | number | null | undefined
) {
  if (value !== undefined && value !== null) {
    if (typeof value === "string") {
      value = Number(value.replaceAll(",", ""));
    }
    return !isNaN(value) && value >= 0 ? value : null;
  }
  return null;
}
